export const APPROVAL_STATUS_LABELS = {
  approved: 'Approved',
  pending: 'Pending',
  rejected: 'Rejected',
  cancelled: 'Cancelled',
};

export const APPROVAL_STATUS_ICONS = {
  approved: 'flsa-check-circle-outline',
  pending: 'ack-clock-outline',
  rejected: 'flsa-file-x',
  cancelled: 'cross-outline',
};

export const APPROVAL_STATUS_CARD_CONFIG = {
  pending: {
    borderClass: 'border-out-of-date',
    iconClass: 'icon-out-of-date',
  },
  rejected: {
    borderClass: 'border-no-survey',
    iconClass: 'icon-no-survey',
  },
  cancelled: {
    borderClass: 'border-pending',
    iconClass: 'icon-pending',
  },
};

export const APPROVAL_STATUS_OPTIONS = [
  { id: 'approved', label: APPROVAL_STATUS_LABELS.approved },
  { id: 'pending', label: APPROVAL_STATUS_LABELS.pending },
  { id: 'rejected', label: APPROVAL_STATUS_LABELS.rejected },
  { id: 'cancelled', label: APPROVAL_STATUS_LABELS.cancelled },
];

export const getPendingSlots = (flow) => (
  (flow?.stages ?? []).flatMap((stage) => stage.slots ?? [])
    .filter((slot) => slot.status === 'pending')
);
